import AspectRatioWrapper from './container'
export default AspectRatioWrapper
